import lodashIncludes from 'lodash-es/includes';

import { Locale } from '~i18n/i18nConfig';

// The i18n module derives an alternate from every key of LOCALE_ISO_MAP, so each language also gets a regional variant
// (`it-IT`) pointing at the very same url. We target languages, not countries, so keep the language-only ones plus x-default.
const ALTERNATE_HREFLANGS: string[] = [...Object.values(Locale), 'x-default'];

// Filtering on resolve rather than on the head entries covers the alternates useSetI18nParams patches in from its own
// entry, which is how the CMS pages get their translated slugs and how they used to slip the regional variants through.
export default defineNuxtPlugin({
    name: 'hreflang-links',
    setup() {
        injectHead().hooks?.hook('tags:resolve', ctx => {
            ctx.tags = ctx.tags.filter(t => t.tag !== 'link' || t.props.rel !== 'alternate' || lodashIncludes(ALTERNATE_HREFLANGS, t.props.hreflang));
        });
    },
});
